import { render, staticRenderFns } from "./CustomSlider.vue?vue&type=template&id=3b3348b5&scoped=true"
import script from "./CustomSlider.vue?vue&type=script&lang=js"
export * from "./CustomSlider.vue?vue&type=script&lang=js"
import style0 from "./CustomSlider.vue?vue&type=style&index=0&id=3b3348b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3348b5",
  null
  
)

export default component.exports